import axios from "../../plugins/axios";
import router from "../../router/index"
import Vuetify from '../../plugins/vuetify'

export default {
    namespaced : true,
    state : {
        name: "",
        initials: "",
        organisation: {
            managed_list:[], 
            crm_list:[],
            details : {}
        },
        admin: false, 
        forms : false,
        managed : false,
        crm : false,
        organisations : [],
        organisation_reference : '', 
        formChange : false,
        authorization : null,
        // specifically for updating passwords
        editPassword: false,
        old_password : null, 
        new_password : null, 
        check_password : null,
        passwordSuccess : false,
        passwordError : false, 
        initializing : false,
        // specific bools for switching of organisation.
        switchedOrganisation : false, 
        switchedOrganisationError : false,
    }, 

    getters : {
        userIsAdmin(state) {
            if (state.authorization == 'superuser') {
                return true
            } else if (state.authorization == 'admin') {
                return true
            } else {
                return false
            }
        }
    }, 
    actions : {
        getUser: ({ state }) => {
            axios.get("/api/user").then(response => {
                state.name                   = response.data.user.full_name;
                state.initials               = response.data.user.initials;
                state.admin                  = response.data.admin;
                state.organisation           = response.data.organisation
                state.organisation_reference = response.data.organisation.reference
                state.authorization          = response.data.user.authorization

                Vuetify.framework.theme.themes.light.primary = response.data.organisation.application_color               

                if (state.organisation.crm_list.length > 0) {
                    router.push("/crm")
                } else {
                    router.push("/contracten")
                }
            });
        },
        fetchUser: ({ state }) => {
            axios.get("/api/user/").then(response => {
                state.name                   = response.data.user.full_name;
                state.initials               = response.data.user.initials;
                state.admin                  = response.data.admin;
                state.organisation           = response.data.organisation
                state.organisation_reference = response.data.organisation.reference
                state.authorization          = response.data.user.authorization
            });
        },
        resetUser: ({state}) => {
            axios.get("/api/user/").then(response => {
                state.name                   = response.data.user.full_name;
                state.initials               = response.data.user.initials;
                state.admin                  = response.data.admin;
                state.organisation           = response.data.organisation;
                state.organisation_reference = response.data.organisation.reference
                state.authorization          = response.data.user.authorization;
            })
        },

        updateUser: ({state, commit, dispatch}) => {

            state.initializing = true;
            axios.post("/api/user/", {
                reference:state.organisation_reference
            }).then(response => {
                dispatch("reinitialize")
            })
        },

        reinitialize : ({state, dispatch, commit}) => {
            dispatch("getUser").then(() => {
                dispatch("getTypes", null, {root:true}).then(()=> {
                    dispatch("getObjects", null, {root:true}).then(()=>{
                        // release loading mode
                        state.initializing = false

                        commit("app/toggleUserSettings", null, {root:true})
                        // show success message
                        state.switchedOrganisation = true
                        
                    }).catch(()=> {
                        // show error
                        state.switchedOrganisationError = true
                        // logout because of error state
                    })
                }).catch(()=> {
                    // show error 
                    state.switchedOrganisationError = true
                    // logout because of error state
                })
            })

        },         

        createOrganisation : ({state, dispatch}, payload) => {
            axios.post("/api/organisations", {
                name : payload.name
            }).then(response => {
                console.log(response)
                state.organisation_reference = response.data.organisation.reference
                dispatch("updateUser")
            })
        },
        getOrganisation : ({state}) => {
            axios.get("/api/organisation").then(response => {
                state.organisation = response.data
            })
        }, 

        updateOrganisation : ({state}) => {
            axios.put("/api/organisation", state.organisation).then(response => {
                state.organisation = response.data
                }
            )
        },
        getOrganisations : ({state}) => {
            axios.get("api/organisations").then(response => {
                state.organisations = response.data
            })
        }, 
        updatePassword : ({state, commit}) => {

            axios.put("api/user/update/password", {
                new_password : state.new_password, 
                old_password : state.old_password
            }).then(() => {
                commit("app/clearUserSettingsPanel", null, {root:true})
                state.new_password = null; 
                state.old_password = null;
                state.check_password = null;
                state.editPassword = false;
                state.passwordSuccess = true;

            }).catch( () => {
                state.passwordError = true
            }
                
            )
        }
        
    }
}